import { DirectionalLight, HemisphereLight } from 'three';
// import * as THREE from "three";

function createLights() {
    /*const ambientLight = new HemisphereLight(
        'white',
        'darkslategray',
        10,
    );

    const mainLight = new DirectionalLight('white', 5);
    mainLight.position.set(10, 10, 10);

    return { ambientLight, mainLight };
*/

    const hemiLight = new HemisphereLight( "#ffffff", "#090808", 3 );
    hemiLight.position.set( 0, 100, 200 );
    // const light = new THREE.AmbientLight( 0x404040 ); // soft white light
    // scene.add( light );

    return hemiLight
}

export { createLights };
